import React, { Component } from "react";
import { Button, Icon, Modal } from "semantic-ui-react";

export class DeliveryReferenceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      deliveryconsigneeList: []
    };
  }
  handleOpenModal = (deliveryconsigneeList) => {
    console.log(this.props)
    var arr = []

    for (let i = 0; i < deliveryconsigneeList.length; i++) {
      var str_array = deliveryconsigneeList[i].split('-');
      let temp = {
        deliveryRefNo: str_array[0], consignee: str_array[1]
      }
      arr.push(temp)
    }

    this.setState({ deliveryconsigneeList: arr }, () => {
    });

    console.log(arr)

    this.setState({ open: true });
  };

  render() {
    return (
      <>
        <div title={this.props.value} onClick={() => this.handleOpenModal(this.props.value)}>{this.props.valueFormatted}</div>

        <Modal
          onClose={() => this.setState({ open: false })}
          //onOpen={() => setOpen(true)}
          open={this.state.open}
        //trigger={<Button>Delivery Reference Number</Button>}
        >
          <Modal.Header>Delivery Reference Number</Modal.Header>
          <Modal.Content>
            <table className="delivery-reference-number-table">
              <thead>
                <tr>
                  <th>Delivery Reference No.</th>
                  <th>Consignee</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.deliveryconsigneeList && this.state.deliveryconsigneeList.map((item, i) => {
                    return (
                      <tr key={i}>
                        <th>{item.deliveryRefNo}</th>
                        <th>{item.consignee}</th>
                      </tr>
                    )
                  })
                }
              </tbody>

            </table>

          </Modal.Content>
          <Modal.Actions>
            <Button basic onClick={() => this.setState({ open: false })}>
              Close
            </Button>
          </Modal.Actions>
        </Modal>
      </>
    );
  }
}

export default DeliveryReferenceModal;
